// @flow

/**
 * Do not edit directly
 * Generated on Thu, 20 Feb 2020 17:25:54 GMT
 */

import Enum from '@rover/react-lib/types/Enum';

type ContrastRating = 'AAA' | 'AA' | '•AA';

type ColorType = {
  name: string,
  rgba: { r: number, g: number, b: number, a: number },
  hex: string,
  blackTextContrastRating?: ContrastRating,
  whiteTextContrastRating?: ContrastRating,
};

export default class Color extends Enum<ColorType> {
  static NEUTRAL_12 = new Color({
    name: 'NEUTRAL_12',
    rgba: { r: 27, g: 31, b: 35, a: 1 },
    hex: '#1B1F23',
    whiteTextContrastRating: 'AAA',
  });

  static NEUTRAL_28 = new Color({
    name: 'NEUTRAL_28',
    rgba: { r: 64, g: 72, b: 79, a: 1 },
    hex: '#40484F',
    whiteTextContrastRating: 'AAA',
  });

  static NEUTRAL_44 = new Color({
    name: 'NEUTRAL_44',
    rgba: { r: 102, g: 114, b: 124, a: 1 },
    hex: '#66727C',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static NEUTRAL_56 = new Color({
    name: 'NEUTRAL_56',
    rgba: { r: 132, g: 144, b: 154, a: 1 },
    hex: '#84909A',
    blackTextContrastRating: 'AA',
    whiteTextContrastRating: '•AA',
  });

  static NEUTRAL_84 = new Color({
    name: 'NEUTRAL_84',
    rgba: { r: 207, g: 215, b: 222, a: 1 },
    hex: '#CFD7DE',
    blackTextContrastRating: 'AAA',
  });

  static NEUTRAL_88 = new Color({
    name: 'NEUTRAL_88',
    rgba: { r: 220, g: 225, b: 229, a: 1 },
    hex: '#DCE1E5',
    blackTextContrastRating: 'AAA',
  });

  static NEUTRAL_92 = new Color({
    name: 'NEUTRAL_92',
    rgba: { r: 232, g: 235, b: 237, a: 1 },
    hex: '#E8EBED',
    blackTextContrastRating: 'AAA',
  });

  static NEUTRAL_96 = new Color({
    name: 'NEUTRAL_96',
    rgba: { r: 244, g: 245, b: 246, a: 1 },
    hex: '#F4F5F6',
    blackTextContrastRating: 'AAA',
  });

  static NEUTRAL_100 = new Color({
    name: 'NEUTRAL_100',
    rgba: { r: 255, g: 255, b: 255, a: 1 },
    hex: '#FFFFFF',
    blackTextContrastRating: 'AAA',
  });

  static GREEN_24 = new Color({
    name: 'GREEN_24',
    rgba: { r: 0, g: 121, b: 72, a: 1 },
    hex: '#007948',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static GREEN_28 = new Color({
    name: 'GREEN_28',
    rgba: { r: 9, g: 136, b: 85, a: 1 },
    hex: '#098855',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: '•AA',
  });

  static GREEN_70 = new Color({
    name: 'GREEN_70',
    rgba: { r: 113, g: 244, b: 191, a: 1 },
    hex: '#71F4BF',
    blackTextContrastRating: 'AAA',
  });

  static GREEN_96 = new Color({
    name: 'GREEN_96',
    rgba: { r: 236, g: 254, b: 247, a: 1 },
    hex: '#ECFEF7',
    blackTextContrastRating: 'AAA',
  });

  static GREEN_BASE = new Color({
    name: 'GREEN_BASE',
    rgba: { r: 20, g: 169, b: 109, a: 1 },
    hex: '#14A96D',
    blackTextContrastRating: 'AA',
  });

  static BLUE_28 = new Color({
    name: 'BLUE_28',
    rgba: { r: 6, g: 116, b: 138, a: 1 },
    hex: '#06748A',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static BLUE_32 = new Color({
    name: 'BLUE_32',
    rgba: { r: 2, g: 129, b: 162, a: 1 },
    hex: '#0281A2',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static BLUE_70 = new Color({
    name: 'BLUE_70',
    rgba: { r: 125, g: 211, b: 232, a: 1 },
    hex: '#7DD3E8',
    blackTextContrastRating: 'AAA',
  });

  static BLUE_96 = new Color({
    name: 'BLUE_96',
    rgba: { r: 236, g: 251, b: 254, a: 1 },
    hex: '#ECFBFE',
    blackTextContrastRating: 'AAA',
  });

  static BLUE_BASE = new Color({
    name: 'BLUE_BASE',
    rgba: { r: 22, g: 162, b: 187, a: 1 },
    hex: '#16A2BB',
    blackTextContrastRating: 'AA',
    whiteTextContrastRating: '•AA',
  });

  static PURPLE_40 = new Color({
    name: 'PURPLE_40',
    rgba: { r: 80, g: 75, b: 180, a: 1 },
    hex: '#504BB4',
    whiteTextContrastRating: 'AA',
  });

  static PURPLE_70 = new Color({
    name: 'PURPLE_70',
    rgba: { r: 138, g: 133, b: 224, a: 1 },
    hex: '#8A85E0',
    blackTextContrastRating: 'AA',
  });

  static PURPLE_96 = new Color({
    name: 'PURPLE_96',
    rgba: { r: 236, g: 236, b: 254, a: 1 },
    hex: '#ECECFE',
    blackTextContrastRating: 'AAA',
  });

  static PURPLE_BASE = new Color({
    name: 'PURPLE_BASE',
    rgba: { r: 105, g: 100, b: 189, a: 1 },
    hex: '#6964BD',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static RED_40 = new Color({
    name: 'RED_40',
    rgba: { r: 194, g: 10, b: 47, a: 1 },
    hex: '#C20A2F',
    whiteTextContrastRating: 'AA',
  });

  static RED_70 = new Color({
    name: 'RED_70',
    rgba: { r: 252, g: 105, b: 123, a: 1 },
    hex: '#FC697B',
    blackTextContrastRating: 'AA',
  });

  static RED_96 = new Color({
    name: 'RED_96',
    rgba: { r: 254, g: 236, b: 238, a: 1 },
    hex: '#FEECEE',
    blackTextContrastRating: 'AAA',
  });

  static RED_BASE = new Color({
    name: 'RED_BASE',
    rgba: { r: 229, g: 26, b: 66, a: 1 },
    hex: '#E51A42',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static ORANGE_40 = new Color({
    name: 'ORANGE_40',
    rgba: { r: 204, g: 78, b: 0, a: 1 },
    hex: '#CC4E00',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static ORANGE_70 = new Color({
    name: 'ORANGE_70',
    rgba: { r: 255, g: 161, b: 102, a: 1 },
    hex: '#FFA166',
    blackTextContrastRating: 'AAA',
  });

  static ORANGE_96 = new Color({
    name: 'ORANGE_96',
    rgba: { r: 254, g: 243, b: 236, a: 1 },
    hex: '#FEF3EC',
    blackTextContrastRating: 'AAA',
  });

  static ORANGE_BASE = new Color({
    name: 'ORANGE_BASE',
    rgba: { r: 255, g: 129, b: 51, a: 1 },
    hex: '#FF8133',
    blackTextContrastRating: 'AA',
  });

  static YELLOW_28 = new Color({
    name: 'YELLOW_28',
    rgba: { r: 140, g: 108, b: 5, a: 1 },
    hex: '#8C6C05',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static YELLOW_70 = new Color({
    name: 'YELLOW_70',
    rgba: { r: 247, g: 217, b: 110, a: 1 },
    hex: '#F7D96E',
    blackTextContrastRating: 'AAA',
  });

  static YELLOW_96 = new Color({
    name: 'YELLOW_96',
    rgba: { r: 254, g: 250, b: 236, a: 1 },
    hex: '#FEFAEC',
    blackTextContrastRating: 'AAA',
  });

  static YELLOW_BASE = new Color({
    name: 'YELLOW_BASE',
    rgba: { r: 255, g: 207, b: 51, a: 1 },
    hex: '#FFCF33',
    blackTextContrastRating: 'AAA',
  });

  static BRAND_ROVER = new Color({
    name: 'BRAND_ROVER',
    rgba: { r: 0, g: 189, b: 112, a: 1 },
    hex: '#00BD70',
    blackTextContrastRating: 'AA',
  });

  static BRAND_DOGBUDDY = new Color({
    name: 'BRAND_DOGBUDDY',
    rgba: { r: 255, g: 90, b: 91, a: 1 },
    hex: '#FF5A5B',
    blackTextContrastRating: 'AA',
    whiteTextContrastRating: '•AA',
  });

  static BRAND_FACEBOOK = new Color({
    name: 'BRAND_FACEBOOK',
    rgba: { r: 59, g: 89, b: 152, a: 1 },
    hex: '#3B5998',
    whiteTextContrastRating: 'AA',
  });

  static BRAND_INSTAGRAM = new Color({
    name: 'BRAND_INSTAGRAM',
    rgba: { r: 138, g: 58, b: 185, a: 1 },
    hex: '#8A3AB9',
    whiteTextContrastRating: 'AA',
  });

  static BRAND_TWITTER = new Color({
    name: 'BRAND_TWITTER',
    rgba: { r: 29, g: 161, b: 242, a: 1 },
    hex: '#1DA1F2',
    blackTextContrastRating: 'AA',
  });

  static BRAND_PINTEREST = new Color({
    name: 'BRAND_PINTEREST',
    rgba: { r: 200, g: 35, b: 44, a: 1 },
    hex: '#C8232C',
    whiteTextContrastRating: 'AA',
  });

  static BRAND_GOOGLE = new Color({
    name: 'BRAND_GOOGLE',
    rgba: { r: 221, g: 75, b: 57, a: 1 },
    hex: '#DD4B39',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: '•AA',
  });

  static isLocked = true;

  toString(): string {
    const { r, g, b, a } = this.value.rgba;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }

  toTestString(): string {
    return this.toString().replace(/\s/g, '');
  }

  toHexString(): string {
    return this.value.hex;
  }

  withOpacity(opacity: number): string {
    const { r, g, b } = this.value.rgba;
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
}



// WEBPACK FOOTER //
// ../design-system/style-dictionary/build/es6/Color.js